var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AdviceBooking from './AdviceBooking';
import AdviceShowBookings from './AdviceShowBookings';
import axios from 'axios';
function Advice({ productType, selectTab, hideContent, document = null }) {
    const [bookings, setBookings] = useState();
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios.get(`/api/bookings?product=${productType}&status=created,rebooked,completed`, { withCredentials: true });
            setBookings(response.data);
        }))();
    }, []);
    return (_jsxs("div", Object.assign({ className: 'p-4 bg-white rounded-t-xl h-full pt-2 pb-20 flex flex-col md:px-2 md:py-0' }, { children: [_jsx("span", Object.assign({ className: 'handle text-dark-teal w-full flex items-center justify-center mb-2 md:hidden', onClick: hideContent }, { children: _jsx("svg", Object.assign({ className: 'fill-current h-6 w-6 transform rotate-90', viewBox: '0 0 32 32', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M13.475 23.475a3.571 3.571 0 105.05 5.05l-5.05-5.05zM26 16l2.525 2.525a3.572 3.572 0 000-5.05L26 16zM18.525 3.475a3.571 3.571 0 10-5.05 5.05l5.05-5.05zm0 25.05l10-10-5.05-5.05-10 10 5.05 5.05zm10-15.05l-10-10-5.05 5.05 10 10 5.05-5.05z' }) })) })), (Array.isArray(bookings) && bookings.length === 0) && (_jsx(AdviceBooking, { productType: productType, document: document })), (Array.isArray(bookings) && bookings.length > 0) && (_jsx(AdviceShowBookings, { selectTab: selectTab, bookings: bookings, product: productType }))] })));
}
Advice.propTypes = {
    productType: PropTypes.string.isRequired,
    selectTab: PropTypes.func.isRequired,
    hideContent: PropTypes.func.isRequired,
    document: PropTypes.shape({
        id: PropTypes.number.isRequired,
        isPurchased: PropTypes.bool.isRequired,
        purchasedAsType: PropTypes.string
    })
};
export default Advice;
